import { Enumeration } from './enum';

/**
 * Class decorator for {@link Enumeration} subclasses that overrides `toJSON`
 * to return the snake_case form of the enum value instead of the raw value.
 *
 * Useful when the backend/API contract expects enums serialized in snake_case
 * (e.g. `payment_method` instead of `paymentMethod`).
 *
 * @example
 * ```ts
 * @SerializeAsSnakeCase
 * class PaymentMethod extends Enumeration {
 *   static readonly creditCard = new PaymentMethod();
 * }
 *
 * JSON.stringify(PaymentMethod.creditCard); // "credit_card"
 * ```
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function SerializeAsSnakeCase<T extends typeof Enumeration>(target: T): T {
	target.prototype.toJSON = function(this: Enumeration): string {
		return this.snakeCase;
	};

	return target;
}
